import { useQuery } from 'react-query';
import CollectionsAPI from 'services/API/CollectionsAPI';
import { PaginatedProject } from 'types';
import { FilterViewEnum } from 'types/FilterProjects';
import type { ProjectFilterRequest } from '@mercator-gcp/types/elastic_search_service/ProjectFilterRequest';

type TUseCollectionProjectsProps = {
  id: number | number[] | undefined;
  page: number;
  activeTabs?: FilterViewEnum[];
  sort?: string[];
  keywords?: ProjectFilterRequest['keywords'];
};

type PaginateCollectionReponse<T> = {
  results: T;
  aggregations?: {
    total_cost: {
      value: number;
    };
    total_estimated_cost: {
      value: number;
    };
  };
  count: number;
  next?: string;
  previous?: string;
  locations?: {
    [key: string]: number;
  };
};

const defaultPaginatedResponse = {
  results: [],
  count: 0,
};

export const useFilterCollectionProjects = ({
  id,
  page = 1,
  activeTabs,
  sort = [],
  keywords,
}: TUseCollectionProjectsProps) => {
  return useQuery(
    ['get-filtered-collection-projects', id, page, activeTabs, sort, keywords],
    async (): Promise<PaginateCollectionReponse<PaginatedProject[]>> => {
      let excludeProperties = {};

      if (activeTabs) {
        excludeProperties =
          activeTabs.length === 0
            ? {
                include_starred_projects: false,
                include_watching_projects: false,
              }
            : {
                include_starred_projects: activeTabs.includes(FilterViewEnum.STAR),
                include_watching_projects: activeTabs.includes(FilterViewEnum.WATCH),
              };
      }

      const result = await CollectionsAPI.postFilterCollectionProjects(
        id as number,
        page,
        {
          ...excludeProperties,
          sort,
          keywords,
        },
      );

      return result?.data || defaultPaginatedResponse;
    },
    { refetchOnWindowFocus: false },
  );
};
